import { IGlobalRolesState } from '@app/store/modules/global'
import { bindFunctions } from '@app/utils/class'
import { getRoles } from '@app/utils/permissions'
import * as React from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import { actionCreators, IUserViewState } from '../modules/userView'

type IComponentProps = IUserViewState &
  IGlobalRolesState &
  RouteComponentProps<{ id: string }> &
  typeof actionCreators

class UserRoles extends React.PureComponent<IComponentProps> {
  public constructor(props: any) {
    super(props)

    bindFunctions(this)
  }

  public render() {
    return (
      <div key={this.props.match.params.id}>
        <div className='mx-2'>{this._renderRoles()}</div>
      </div>
    )
  }

  private _renderRoles() {
    const roles = getRoles(this.props.roles, this.props.item.user).map((item) => {
      return (
        <div key={item} className='d-flex flex-row flex-wrap mt-2'>
          <div style={{ width: '40%', fontWeight: 'bold' }}>{item.name}</div>
          <div>{item.description}</div>
        </div>
      )
    })

    return <div>{roles}</div>
  }
}

export default withRouter(UserRoles)
